import { render, staticRenderFns } from "./CertSpecOprav.vue?vue&type=template&id=4c67e227&"
import script from "./CertSpecOprav.vue?vue&type=script&lang=ts&"
export * from "./CertSpecOprav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports